import { createReducer } from "@reduxjs/toolkit";
import { studentRetrieveAllAttendanceSheets } from "./retrieve-attendance-sheets";
import type { AttendanceSheetVM } from "@shared-kernel/application/ports/student/student-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<AttendanceSheetVM[]> = { fetching: "pending", data: [] };

export const studentRetrieveAttendanceSheetsReducer = createReducer<RetrievalState<AttendanceSheetVM[]>>(initialState, builder => {
  builder.addCase(studentRetrieveAllAttendanceSheets.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(studentRetrieveAllAttendanceSheets.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(studentRetrieveAllAttendanceSheets.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
